export const TRANSITION_ALL_STYLE = 'all 150ms ease-out';
